export enum EAssetType {
  FIREARM = 'FIREARM',
  ACCESSORY = 'ACCESSORY',
  AMMUNITION = 'AMMUNITION',
  COMPONENT = 'COMPONENT',
}
